// removed by extract-text-webpack-plugin
module.exports = {"app":"App__app___eX7W9","header":"App__header___95Ita","content":"App__content___3CYEs","stage":"App__stage___1aT9_","footer":"App__footer___244pL","logo":"App__logo___377kw","beta-label":"App__beta-label___2vU_G"};


//////////////////
// WEBPACK FOOTER
// ./src/App/App.scss
// module id = 98
// module chunks = 0